// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"cn-z","badgeLink":"dn-z","category":"en-z"};